import React from 'react';
import { ArrowRightIcon, BookOpenCheckIcon, CheckCircle2Icon, HeartPulseIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getCheckoutUrl, getStudyUrl } from '../../../utils/studyAccess';
import { useStudyMembership } from '../../../utils/useStudyMembership';
const PROGRAM_ID = 'rd-ready-cnsc-prep' as const;
const includedFeatures = ['A dedicated CNSC study workspace', 'Focused nutrition support review', 'Flexible sessions that fit your schedule'];
export function CNSCPrep() {
  const membership = useStudyMembership(PROGRAM_ID);
  const hasAccess = membership.hasAccess;
  return <div className="min-h-screen w-full bg-[#e8f8f6] text-slate-900" data-id="element-1960">
      <section className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:items-center lg:py-24" data-id="element-1961">
        <div data-id="element-1962">
          <p className="inline-flex items-center gap-2 rounded-full bg-[#ffe36e] px-4 py-2 text-sm font-bold" data-id="element-1963">
            <HeartPulseIcon className="h-4 w-4" aria-hidden="true" data-id="element-1964" />
            CNSC Exam Prep
          </p>
          <h1 className="mt-6 text-5xl font-black tracking-[-0.05em] sm:text-6xl" data-id="element-1965">
            Build clinical confidence,
            <span className="text-[#0b8776]" data-id="element-1966"> one session at a time.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-8 text-slate-700" data-id="element-1967">
            Unlock your account-bound CNSC study system for a one-time $150
            purchase, then return whenever you are ready to review.
          </p>
          <Link to={hasAccess ? getStudyUrl(PROGRAM_ID) : getCheckoutUrl(PROGRAM_ID)} className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0b8776] px-6 py-3.5 font-bold text-white transition hover:bg-[#086f61] focus:outline-none focus:ring-4 focus:ring-[#0b8776]/30" data-id="element-1968">
            {hasAccess ? 'Open study' : 'Unlock CNSC Prep · $150'}
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1969" />
          </Link>
        </div>

        <aside className="rounded-[2rem] border-4 border-slate-900 bg-white p-7 shadow-[8px_8px_0_#172033] sm:p-9" aria-label="CNSC Prep includes" data-id="element-1970">
          <BookOpenCheckIcon className="h-11 w-11 text-[#0b8776]" aria-hidden="true" data-id="element-1971" />
          <h2 className="mt-7 text-3xl font-black tracking-[-0.04em]" data-id="element-1972">
            Included with your purchase
          </h2>
          <ul className="mt-7 space-y-4" data-id="element-1973">
            {includedFeatures.map(feature => <li key={feature} className="flex items-start gap-3 text-base font-semibold text-slate-700" data-id="element-1974">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#0b8776]" aria-hidden="true" data-id="element-1975" />
                {feature}
              </li>)}
          </ul>
          <p className="mt-8 rounded-2xl bg-[#d6f7f0] p-4 text-sm font-semibold text-slate-700" data-id="element-1976">
            One-time $150 purchase. Access is tied to the RD Ready account used
            at checkout.
          </p>
        </aside>
      </section>

      <section className="bg-[#172033] px-5 py-16 text-white sm:px-8" data-id="element-1977">
        <div className="mx-auto max-w-6xl rounded-[2rem] border-2 border-white/30 bg-[#274458] p-8 sm:p-10" data-id="element-1978">
          <h2 className="text-3xl font-black tracking-[-0.04em]" data-id="element-1979">
            Ready to pick up your prep?
          </h2>
          <p className="mt-3 max-w-2xl text-lg text-slate-200" data-id="element-1980">
            {hasAccess ? 'Your CNSC workspace is unlocked and ready for your next session.' : 'Purchase CNSC Exam Prep to unlock your focused study workspace.'}
          </p>
          <Link to={hasAccess ? getStudyUrl(PROGRAM_ID) : getCheckoutUrl(PROGRAM_ID)} className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#ffe36e] px-6 py-3.5 font-bold text-slate-900 transition hover:bg-white focus:outline-none focus:ring-4 focus:ring-[#ffe36e]/40" data-id="element-1981">
            {hasAccess ? 'Open study' : 'Unlock for $150'}
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1982" />
          </Link>
        </div>
      </section>
    </div>;
}